<div class="sell-page">
  <app-header></app-header>

  <div class="sell-container">
    <div class="progress-steps">
      <div
        class="step"
        [class.active]="currentStep >= 1"
        [class.completed]="currentStep > 1"
      >
        <div class="step-number">1</div>
        <div class="step-label">Category</div>
      </div>
      <div
        class="step"
        [class.active]="currentStep >= 2"
        [class.completed]="currentStep > 2"
      >
        <div class="step-number">2</div>
        <div class="step-label">Subcategory</div>
      </div>
      <div
        class="step"
        [class.active]="currentStep >= 3"
        [class.completed]="currentStep > 3"
      >
        <div class="step-number">3</div>
        <div class="step-label">Details</div>
      </div>
      <div
        class="step"
        *ngIf="isVehicleCategory"
        [class.active]="currentStep >= 4"
        [class.completed]="currentStep > 4"
      >
        <div class="step-number">4</div>
        <div class="step-label">Features</div>
      </div>
      <div
        class="step"
        [class.active]="currentStep >= (isVehicleCategory ? 5 : 4)"
        [class.completed]="currentStep > (isVehicleCategory ? 5 : 4)"
      >
        <div class="step-number">{{ isVehicleCategory ? 5 : 4 }}</div>
        <div class="step-label">Plan</div>
      </div>
      <div class="step" [class.active]="currentStep >= actualTotalSteps">
        <div class="step-number">{{ actualTotalSteps }}</div>
        <div class="step-label">Review</div>
      </div>
    </div>

    <div class="step-content" *ngIf="currentStep === 1" [@fadeAnimation]>
      <div class="step-header">
        <h1>Choose a Category</h1>
        <p>
          Select the category that best describes what you want to sell or offer
        </p>
      </div>

      <div class="loading-state" *ngIf="loadingCategories">
        <div class="spinner"></div>
        <p>Loading categories...</p>
      </div>

      <div
        class="categories-grid"
        *ngIf="!loadingCategories && categories.length > 0"
      >
        <div
          *ngFor="let category of categories"
          class="category-card"
          [class.selected]="selectedCategory?.slug === category.slug"
          (click)="selectCategory(category)"
        >
          <div class="category-icon">
            <ng-container [ngSwitch]="category.slug">
              <img
                *ngSwitchCase="'vehicles'"
                class="categoryIconVehicle"
                src="assets/images/categoriesIcon/vehicles.png"
                alt="Vehicles"
                width="155"
                height="155"
              />
              <img
                *ngSwitchCase="'real-estate'"
                class="categoryIconRealEstate"
                src="assets/images/categoriesIcon/realEstate.png"
                alt="Real Estate"
                width="155"
                height="155"
              />
              <img
                *ngSwitchCase="'marketplace'"
                class="categoryIconMarketplace"
                src="assets/images/categoriesIcon/marketplace.png"
                alt="Marketplace"
                width="155"
                height="155"
              />
              <img
                *ngSwitchCase="'jobs'"
                class="categoryIconJobs"
                src="assets/images/categoriesIcon/jobs.png"
                alt="Jobs"
                width="155"
                height="155"
              />
              <svg
                *ngSwitchDefault
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="16"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </ng-container>
          </div>
          <h3>{{ category.name }}</h3>
          <p>{{ category.description }}</p>
        </div>
      </div>
    </div>

    <div class="step-content" *ngIf="currentStep === 2" [@fadeAnimation]>
      <div class="step-header">
        <h1>Choose a Subcategory</h1>
        <p>Select the specific type within {{ selectedCategory?.name }}</p>
      </div>

      <div class="loading-state" *ngIf="loadingSubcategories">
        <div class="spinner"></div>
        <p>Loading subcategories...</p>
      </div>

      <div
        class="subcategories-grid"
        *ngIf="!loadingSubcategories && subcategories.length > 0"
      >
        <div
          *ngFor="let subcategory of subcategories"
          class="subcategory-card"
          [class.selected]="selectedSubcategory?.slug === subcategory.slug"
          (click)="selectSubcategory(subcategory)"
        >
          <div class="subcategory-icon">
            <img
              [src]="getSubcategoryImage(subcategory.slug).src"
              [alt]="getSubcategoryImage(subcategory.slug).alt"
              [width]="getSubcategoryImage(subcategory.slug).width"
              [height]="getSubcategoryImage(subcategory.slug).height"
              [class]="getSubcategoryImage(subcategory.slug).className"
              (error)="onImageError($event)"
            />
          </div>
          <h4>{{ subcategory.name }}</h4>
          <p>{{ subcategory.description }}</p>
        </div>
      </div>

      <div class="step-actions">
        <button class="btn btn-secondary" (click)="previousStep()">Back</button>
      </div>
    </div>

    <div class="step-content" *ngIf="currentStep === 3" [@fadeAnimation]>
      <div class="step-header">
        <h1>Listing Details</h1>
        <p>Provide information about your {{ selectedSubcategory?.name }}</p>
      </div>

      <div class="form-section">
        <app-image-upload
          [maxImages]="42"
          [maxSizeMB]="20"
          [required]="false"
          [autoUpload]="true"
          (imagesChange)="onImagesChange($event)"
          (uploadComplete)="onImageUploadComplete($event)"
          (uploadProgress)="onImageUploadProgress($event)"
        ></app-image-upload>

        <div class="image-plan-info" *ngIf="uploadedImageUrls.length > 0">
          <div class="plan-breakdown">
            <div
              class="breakdown-item"
              [class.exceeds]="uploadedImageUrls.length > 7"
              [class.fits]="uploadedImageUrls.length <= 7"
            >
              <span class="plan-name">Free (7)</span>
              <span class="status">{{
                uploadedImageUrls.length <= 7 ? "✓" : "⚠"
              }}</span>
            </div>
            <div
              class="breakdown-item"
              [class.exceeds]="uploadedImageUrls.length > 14"
              [class.fits]="uploadedImageUrls.length <= 14"
            >
              <span class="plan-name">Starter (14)</span>
              <span class="status">{{
                uploadedImageUrls.length <= 14 ? "✓" : "⚠"
              }}</span>
            </div>
            <div
              class="breakdown-item"
              [class.exceeds]="uploadedImageUrls.length > 21"
              [class.fits]="uploadedImageUrls.length <= 21"
            >
              <span class="plan-name">Pro (21)</span>
              <span class="status">{{
                uploadedImageUrls.length <= 21 ? "✓" : "⚠"
              }}</span>
            </div>
            <div class="breakdown-item fits">
              <span class="plan-name">Elite (42)</span>
              <span class="status">✓</span>
            </div>
          </div>

          <div class="image-counter">
            <span
              class="counter-text"
              [class.approaching-limit]="uploadedImageUrls.length > 35"
              [class.at-limit]="uploadedImageUrls.length >= 42"
            >
              {{ uploadedImageUrls.length }}/42 images uploaded
            </span>
          </div>

          <div
            class="plan-validation-error"
            *ngIf="getImagePlanValidationError()"
          >
            <div class="error-icon">⚠️</div>
            {{ getImagePlanValidationError() }}
          </div>
        </div>
      </div>

      <form [formGroup]="listingForm" class="listing-form">
        <div class="form-grid">
          <div
            *ngFor="let field of formFields"
            class="form-group"
            [class.full-width]="field.type === 'textarea'"
          >
            <label [for]="field.name">
              {{ field.label }}
              <span class="required" *ngIf="field.required">*</span>
            </label>

            <input
              *ngIf="
                field.type === 'text' ||
                field.type === 'email' ||
                field.type === 'tel'
              "
              [type]="field.type"
              [id]="field.name"
              [formControlName]="field.name"
              [placeholder]="field.placeholder || ''"
              class="form-control"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            />

            <app-vehicle-selector
              *ngIf="field.type === 'vehicle-selector'"
              [formControlName]="field.name"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            ></app-vehicle-selector>

            <app-motorcycle-brand-selector
              *ngIf="field.type === 'motorcycle-brand-selector'"
              [formControlName]="field.name"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            ></app-motorcycle-brand-selector>

            <app-location-autocomplete
              *ngIf="field.type === 'location'"
              [formControlName]="field.name"
              [placeholder]="field.placeholder || 'Start typing a city name...'"
              [inputClass]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
                  ? 'invalid'
                  : ''
              "
              (locationSelected)="onLocationSelected($event)"
              (locationSelectedWithCoords)="
                onLocationSelectedWithCoords($event)
              "
            ></app-location-autocomplete>

            <input
              *ngIf="field.type === 'number'"
              type="number"
              [id]="field.name"
              [formControlName]="field.name"
              [placeholder]="field.placeholder || ''"
              [step]="field.step || 1"
              [min]="field.min || null"
              [max]="field.max || null"
              class="form-control"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            />

            <input
              *ngIf="field.type === 'date'"
              type="date"
              [id]="field.name"
              [formControlName]="field.name"
              class="form-control"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            />

            <div *ngIf="field.type === 'textarea'" class="textarea-container">
              <div
                class="description-layout"
                *ngIf="field.name === 'description'"
              >
                <div class="description-input-area">
                  <textarea
                    [id]="field.name"
                    [formControlName]="field.name"
                    [placeholder]="field.placeholder || ''"
                    [rows]="field.rows || 4"
                    maxlength="5000"
                    class="form-control"
                    [class.invalid]="
                      listingForm.get(field.name)?.invalid &&
                      listingForm.get(field.name)?.touched
                    "
                  ></textarea>

                  <div
                    *ngIf="
                      listingForm.get(field.name)?.invalid &&
                      listingForm.get(field.name)?.touched
                    "
                    class="error-message"
                  >
                    <span
                      *ngIf="listingForm.get(field.name)?.errors?.['required']"
                    >
                      {{ field.label }} is required
                    </span>
                    <span
                      *ngIf="listingForm.get(field.name)?.errors?.['minlength']"
                    >
                      Minimum length is
                      {{ listingForm.get(field.name)?.errors?.['minlength'].requiredLength }}
                      characters
                    </span>
                    <span
                      *ngIf="listingForm.get(field.name)?.errors?.['maxlength']"
                    >
                      Maximum length is
                      {{ listingForm.get(field.name)?.errors?.['maxlength'].requiredLength }}
                      characters
                    </span>
                  </div>
                </div>

                <div class="description-actions">
                  <button
                    type="button"
                    class="btn-generate-description"
                    [disabled]="!canGenerateDescription()"
                    [class.generating]="isGeneratingDescription"
                    [class.success]="
                      generatedDescriptionMetadata &&
                      !descriptionGenerationError
                    "
                    [class.error]="descriptionGenerationError"
                    (click)="generateDescription()"
                    [title]="getGenerateButtonTooltip()"
                  >
                    <svg
                      *ngIf="
                        !isGeneratingDescription &&
                        !generatedDescriptionMetadata &&
                        !descriptionGenerationError
                      "
                      class="ai-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                      />
                      <path
                        d="M19 14L19.8 16.2L22 17L19.8 17.8L19 20L18.2 17.8L16 17L18.2 16.2L19 14Z"
                      />
                      <path
                        d="M5 14L5.8 16.2L8 17L5.8 17.8L5 20L4.2 17.8L2 17L4.2 16.2L5 14Z"
                      />
                    </svg>

                    <div *ngIf="isGeneratingDescription" class="ai-loading">
                      <div class="loading-dot"></div>
                      <div class="loading-dot"></div>
                      <div class="loading-dot"></div>
                    </div>

                    <svg
                      *ngIf="
                        generatedDescriptionMetadata &&
                        !descriptionGenerationError
                      "
                      class="success-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>

                    <svg
                      *ngIf="descriptionGenerationError"
                      class="error-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </button>

                  <button
                    type="button"
                    class="btn-clear-description"
                    [disabled]="!listingForm.get('description')?.value"
                    (click)="clearGeneratedDescription()"
                    title="Clear description and start over"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M3 6h18" />
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                    </svg>
                  </button>
                </div>
              </div>

              <textarea
                *ngIf="field.name !== 'description'"
                [id]="field.name"
                [formControlName]="field.name"
                [placeholder]="field.placeholder || ''"
                [rows]="field.rows || 4"
                maxlength="5000"
                class="form-control"
                [class.invalid]="
                  listingForm.get(field.name)?.invalid &&
                  listingForm.get(field.name)?.touched
                "
              ></textarea>

              <div
                class="generation-status-enhanced"
                *ngIf="
                  field.name === 'description' &&
                  (generatedDescriptionMetadata || descriptionGenerationError)
                "
              >
                <div
                  class="status-success"
                  *ngIf="
                    generatedDescriptionMetadata && !descriptionGenerationError
                  "
                >
                  <div class="status-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M9 12l2 2 4-4" />
                      <circle cx="12" cy="12" r="10" />
                    </svg>
                  </div>
                  <div class="status-content">
                    <div class="status-title">
                      ✨ AI Description Generated Successfully!
                    </div>
                    <div class="status-details">
                      {{ generatedDescriptionMetadata.wordCount }} words •
                      {{ generatedDescriptionMetadata.characterCount }}
                      characters • Perfect for
                      {{ generatedDescriptionMetadata.planName }} plan
                    </div>
                  </div>
                </div>

                <div class="status-error" *ngIf="descriptionGenerationError">
                  <div class="status-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </div>
                  <div class="status-content">
                    <div class="status-title">Generation Failed</div>
                    <div class="status-details">
                      {{ descriptionGenerationError }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <select
              *ngIf="field.type === 'select'"
              [id]="field.name"
              [formControlName]="field.name"
              class="form-control"
              [class.invalid]="
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
            >
              <option value="">Select {{ field.label }}</option>
              <option
                *ngFor="let option of field.options"
                [value]="option.value"
              >
                {{ option.label }}
              </option>
            </select>

            <div
              *ngIf="field.type === 'first_registration_dropdown' || field.type === 'registered_until_dropdown'"
              class="first-registration-container"
            >
              <div class="dropdown-group">
                <select
                  [id]="field.name + '_month'"
                  class="form-control dropdown-half"
                  (change)="onDateMonthChange($event, field.name)"
                  [class.invalid]="
        listingForm.get(field.name)?.invalid &&
        listingForm.get(field.name)?.touched
      "
                >
                  <option value="">Month</option>
                  <option
                    *ngFor="let month of monthOptions"
                    [value]="month.value"
                    [disabled]="isMonthDisabled(month.value, field.name)"
                  >
                    {{ month.label }}
                  </option>
                </select>

                <select
                  [id]="field.name + '_year'"
                  class="form-control dropdown-half"
                  (change)="onDateYearChange($event, field.name)"
                  [class.invalid]="
        listingForm.get(field.name)?.invalid &&
        listingForm.get(field.name)?.touched
      "
                >
                  <option value="">Year</option>
                  <option *ngFor="let year of getYearOptionsForField(field.name)" [value]="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>

            <label *ngIf="field.type === 'checkbox'" class="checkbox-wrapper">
              <input
                type="checkbox"
                [id]="field.name"
                [formControlName]="field.name"
              />
              {{ field.label }}
            </label>

            <small *ngIf="field.hint" class="field-hint">{{
              field.hint
            }}</small>

            <div *ngIf="field.name === 'description'" class="character-counter">
              <span
                class="counter-text"
                [class.approaching-limit]="getDescriptionLength() > 4000"
                [class.at-limit]="getDescriptionLength() >= 5000"
              >
                {{ getDescriptionLength() }}/5000 characters
              </span>

              <div class="plan-breakdown" *ngIf="getDescriptionLength() > 0">
                <div
                  class="breakdown-item"
                  [class.exceeds]="getDescriptionLength() > 300"
                  [class.fits]="getDescriptionLength() <= 300"
                >
                  <span class="plan-name">Free (300)</span>
                  <span class="status">{{
                    getDescriptionLength() <= 300 ? "✓" : "⚠"
                  }}</span>
                </div>
                <div
                  class="breakdown-item"
                  [class.exceeds]="getDescriptionLength() > 400"
                  [class.fits]="getDescriptionLength() <= 400"
                >
                  <span class="plan-name">Starter (400)</span>
                  <span class="status">{{
                    getDescriptionLength() <= 400 ? "✓" : "⚠"
                  }}</span>
                </div>
                <div
                  class="breakdown-item"
                  [class.exceeds]="getDescriptionLength() > 500"
                  [class.fits]="getDescriptionLength() <= 500"
                >
                  <span class="plan-name">Pro (500)</span>
                  <span class="status">{{
                    getDescriptionLength() <= 500 ? "✓" : "⚠"
                  }}</span>
                </div>
                <div class="breakdown-item fits">
                  <span class="plan-name">Elite (5000)</span>
                  <span class="status">✓</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="
                field.name !== 'description' &&
                listingForm.get(field.name)?.invalid &&
                listingForm.get(field.name)?.touched
              "
              class="error-message"
            >
              <span *ngIf="listingForm.get(field.name)?.errors?.['required']">
                {{ field.label }} is required
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['minlength']">
                Minimum length is
                {{ listingForm.get(field.name)?.errors?.['minlength'].requiredLength }}
                characters
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['maxlength']">
                Maximum length is
                {{ listingForm.get(field.name)?.errors?.['maxlength'].requiredLength }}
                characters
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['min']">
                Minimum value is
                {{ listingForm.get(field.name)?.errors?.['min'].min }}
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['max']">
                Maximum value is
                {{ listingForm.get(field.name)?.errors?.['max'].max }}
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['email']">
                Please enter a valid email address
              </span>
              <span *ngIf="listingForm.get(field.name)?.errors?.['notInteger']">
                Only whole numbers allowed (no decimals)
              </span>
            </div>
          </div>
        </div>
      </form>

      <div class="step-actions">
        <button class="btn btn-secondary" (click)="previousStep()">Back</button>
        <button
          class="btn btn-primary"
          [disabled]="!canProceedFromDetails()"
          (click)="nextStep()"
        >
          <span *ngIf="!isCheckingImages">Continue</span>
          <span *ngIf="isCheckingImages" class="checking-text">
            <div class="inline-spinner"></div>
            Checking images...
          </span>
        </button>
      </div>
    </div>

    <div class="step-content" *ngIf="currentStep === 4 && isVehicleCategory" [@fadeAnimation]>
      <div class="step-header">
        <h1>Select Features</h1>
        <p>
          Choose the features that apply to your {{ selectedSubcategory?.name }}
        </p>
      </div>

      <div class="loading-state" *ngIf="loadingFeatures">
        <div class="spinner"></div>
        <p>Loading vehicle features...</p>
      </div>

      <div
        class="features-container"
        *ngIf="
          !loadingFeatures &&
          vehicleFeatures &&
          (vehicleFeatures | keyvalue).length > 0
        "
      >
        <div class="features-selection">
          <div class="features-summary">
            <span class="selected-count"
              >{{ selectedFeatures.length }} features selected</span
            >
            <div class="feature-actions">
              <button
                type="button"
                class="btn-link"
                (click)="selectAllFeatures()"
              >
                Select All
              </button>
              <button
                type="button"
                class="btn-link"
                (click)="clearAllFeatures()"
              >
                Clear All
              </button>
            </div>
          </div>

          <div
            *ngFor="let category of vehicleFeatures | keyvalue"
            class="feature-category"
          >
            <div class="category-header">
              <h3>{{ formatCategoryName(category.key) }}</h3>
              <span class="category-count"
                >{{ getSelectedFeaturesInCategory(category.value).length }}/{{
                  category.value.length
                }}</span
              >
            </div>

            <div class="features-grid">
              <label
                *ngFor="let feature of category.value"
                class="feature-item"
              >
                <input
                  type="checkbox"
                  [value]="feature.id"
                  [checked]="selectedFeatures.includes(feature.id)"
                  (change)="onFeatureChange(feature.id, $event)"
                />
                <div class="feature-info">
                  <span class="feature-name">{{ feature.feature_name }}</span>
                  <span
                    class="feature-description"
                    *ngIf="feature.description"
                    >{{ feature.description }}</span
                  >
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div
        class="no-features"
        *ngIf="
          !loadingFeatures &&
          (!vehicleFeatures || (vehicleFeatures | keyvalue).length === 0)
        "
      >
        <div class="no-features-message">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <h3>No features available</h3>
          <p>This subcategory doesn't have additional features to select.</p>
        </div>
      </div>

      <div class="step-actions">
        <button class="btn btn-secondary" (click)="previousStep()">Back</button>
        <button
          class="btn btn-primary"
          [disabled]="loadingFeatures"
          (click)="nextStep()"
        >
          Continue
        </button>
      </div>
    </div>

    <div
      class="step-content"
      *ngIf="currentStep === (isVehicleCategory ? 5 : 4)"
      [@fadeAnimation]
    >
      <div class="step-header">
        <h1>Choose Your Listing Plan</h1>
        <p>Select the plan that best suits your needs</p>
      </div>

      <div
        class="free-relist-banner"
        *ngIf="
          hasFreeRelistCredits && currentStep === (isVehicleCategory ? 5 : 4)
        "
      >
        <div class="free-relist-content">
          <div class="relist-icon">🎁</div>
          <div class="relist-info">
            <h3>Free Relist Available!</h3>
            <p>{{ freeRelistCredits?.message }}</p>

            <div
              class="credit-breakdown"
              *ngIf="
                freeRelistCredits?.details &&
                freeRelistCredits.details.length > 0
              "
            >
              <small>
                <strong>Available from:</strong>
                <span
                  *ngIf="
                    freeRelistCredits.active_credits &&
                    freeRelistCredits.active_credits > 0
                  "
                >
                  {{ freeRelistCredits.active_credits }} active Elite listing{{
                    freeRelistCredits.active_credits !== 1 ? "s" : ""
                  }}
                </span>
                <span
                  *ngIf="
                    freeRelistCredits.active_credits &&
                    freeRelistCredits.expired_credits &&
                    freeRelistCredits.active_credits > 0 &&
                    freeRelistCredits.expired_credits > 0
                  "
                >
                  ,
                </span>
                <span
                  *ngIf="
                    freeRelistCredits.expired_credits &&
                    freeRelistCredits.expired_credits > 0
                  "
                >
                  {{ freeRelistCredits.expired_credits }} expired Elite
                  listing{{
                    freeRelistCredits.expired_credits !== 1 ? "s" : ""
                  }}
                </span>
              </small>
            </div>

            <button
              class="btn-relist-toggle"
              [class.active]="usingFreeRelist"
              (click)="toggleFreeRelist()"
            >
              <span *ngIf="!usingFreeRelist">🔓 Use Free Relist ($0.00)</span>
              <span *ngIf="usingFreeRelist">💰 Use Regular Pricing</span>
            </button>
          </div>
        </div>
      </div>

      <div class="balance-info">
        <div class="current-balance">
          <span class="label">Your current balance:</span>
          <span class="amount">{{ formatBalance(currentUser?.balance) }}</span>
        </div>
      </div>

      <div
        class="plan-validation-error"
        *ngIf="showPlanUpgradeSuggestion && suggestedPlan"
      >
        <div class="error-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div class="error-content">
          <strong>Content exceeds plan limits!</strong>
          <p>{{ errorMessage }}</p>

          <div class="error-actions">
            <button
              class="btn btn-primary"
              *ngIf="suggestedPlan && canAffordPlan(suggestedPlan)"
              (click)="acceptSuggestedPlan()"
            >
              Upgrade to {{ suggestedPlan.name }} Plan (${{
                suggestedPlan.price
              }})
            </button>

            <button class="btn btn-secondary" (click)="goBackToReduceContent()">
              Go Back & Reduce Content
            </button>

            <button class="btn btn-link" (click)="dismissUpgradeSuggestion()">
              Continue Anyway
            </button>
          </div>

          <div
            class="insufficient-balance-warning"
            *ngIf="suggestedPlan && !canAffordPlan(suggestedPlan)"
          >
            <p>
              <strong
                >Insufficient balance for {{ suggestedPlan.name }} plan.</strong
              >
              You need ${{
                (suggestedPlan.price - (currentUser?.balance || 0)).toFixed(2)
              }}
              more. Please top up your balance or reduce your content.
            </p>
          </div>
        </div>
      </div>

      <div
        class="plan-upgrade-suggestion"
        *ngIf="showPlanUpgradeSuggestion && suggestedPlan"
      >
        <div class="suggestion-header">
          <svg
            class="suggestion-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
          </svg>
          <h3 class="suggestion-title">Upgrade Recommended</h3>
        </div>
        <p class="suggestion-text">
          Your content requires more features than your current plan allows. We
          recommend the <strong>{{ suggestedPlan.name }} plan</strong> for the
          best experience.
        </p>

        <div class="suggestion-comparison">
          <div class="current-vs-suggested">
            <div class="comparison-item">
              <span class="label">Your content:</span>
              <span class="value">
                {{ uploadedImageUrls.length }} images,
                {{ getDescriptionLength() }} characters
              </span>
            </div>
            <div class="comparison-item">
              <span class="label">{{ selectedPlan?.name }} plan allows:</span>
              <span class="value">
                {{ selectedPlan?.features?.imagesAllowed }} images,
                {{ selectedPlan?.features?.descriptionLength }} characters
              </span>
            </div>
            <div class="comparison-item highlight">
              <span class="label">{{ suggestedPlan.name }} plan allows:</span>
              <span class="value">
                {{ suggestedPlan.features.imagesAllowed }} images,
                {{ suggestedPlan.features.descriptionLength }} characters
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="plans-grid">
        <div
          *ngFor="let plan of plans"
          class="plan-card"
          [class.selected]="selectedPlan?.name === plan.name"
          [class.popular]="plan.popular"
          [class.insufficient-balance]="!canAffordPlan(plan)"
          [class.content-exceeds]="!canContentFitInPlan(plan)"
          (click)="selectPlan(plan)"
        >
          <div
            class="content-warning"
            *ngIf="!canContentFitInPlan(plan)"
            title="Your current content exceeds this plan's limits"
          >
            ⚠️ Content too large
          </div>

          <div class="plan-header" [style.background]="plan.gradient">
            <h3>{{ plan.name }}</h3>
            <div class="plan-price">
              <span
                class="currency"
                *ngIf="getEffectivePlanPrice(plan) > 0"
              ></span>
              <span class="amount">{{ formatEffectivePlanPrice(plan) }}</span>
              <div
                class="original-price"
                *ngIf="usingFreeRelist && plan.price > 0"
              >
                <span class="strikethrough">${{ plan.price }}</span>
              </div>
            </div>
          </div>

          <div class="plan-features">
            <div class="feature">
              <strong>📅 Duration:</strong>
              {{ plan.features.listingDuration }} days
            </div>
            <div class="feature">
              <strong>📸 Images:</strong>
              {{ plan.displayFeatures.imagesAllowed }}
            </div>
            <div class="feature">
              <strong>📝 Description:</strong>
              {{ plan.displayFeatures.descriptionLength }}
            </div>
            <div class="feature">
              <strong>🔍 Higher in Search:</strong>
              <span
                [class]="
                  plan.displayFeatures.appearsHigherInSearch === 'Yes'
                    ? 'feature-yes'
                    : 'feature-no'
                "
              >
                {{ plan.displayFeatures.appearsHigherInSearch }}
              </span>
            </div>
            <div class="feature">
              <strong>⭐ Featured Section:</strong>
              <span
                [class]="
                  plan.displayFeatures.listingInFeaturedSection === 'Yes'
                    ? 'feature-yes'
                    : 'feature-no'
                "
              >
                {{ plan.displayFeatures.listingInFeaturedSection }}
              </span>
            </div>
            <div class="feature">
              <strong>💡 Suggested Items:</strong>
              <span
                [class]="
                  plan.displayFeatures.listingInSuggestedItems === 'Yes'
                    ? 'feature-yes'
                    : 'feature-no'
                "
              >
                {{ plan.displayFeatures.listingInSuggestedItems }}
              </span>
            </div>
            <div class="feature">
              <strong>📧 Email Notifications:</strong>
              <span
                [class]="
                  plan.displayFeatures.emailNotificationToSubscribers === 'Yes'
                    ? 'feature-yes'
                    : 'feature-no'
                "
              >
                {{ plan.displayFeatures.emailNotificationToSubscribers }}
              </span>
            </div>
            <div class="feature">
              <strong>🔄 Free Relist:</strong>
              <span
                [class]="
                  plan.displayFeatures.freeRelist.includes('Yes')
                    ? 'feature-yes'
                    : 'feature-no'
                "
              >
                {{ plan.displayFeatures.freeRelist }}
              </span>
            </div>
          </div>

          <div *ngIf="!canAffordPlan(plan)" class="insufficient-funds">
            Insufficient balance - Need ${{
              (plan.price - (currentUser?.balance || 0)).toFixed(2)
            }}
            more
          </div>

          <div *ngIf="!canAffordPlan(plan)" class="insufficient-funds">
            Insufficient balance - Need ${{
              (plan.price - (currentUser?.balance || 0)).toFixed(2)
            }}
            more
          </div>
        </div>
      </div>

      <div class="step-actions">
        <button class="btn btn-secondary" (click)="previousStep()">Back</button>
        <button
          class="btn btn-primary"
          [disabled]="!selectedPlan || !canAffordPlan(selectedPlan)"
          (click)="nextStep()"
        >
          Continue
        </button>
      </div>
    </div>

    <div class="step-content" *ngIf="currentStep === actualTotalSteps" [@fadeAnimation]>
      <div class="step-header">
        <h1>Review Your Listing</h1>
        <p>Please review all details before publishing your listing</p>
      </div>

      <div class="review-sections">
        <div class="review-section">
          <h3>Category & Type</h3>
          <div class="review-item">
            <span class="label">Category:</span>
            <span class="value">{{ selectedCategory?.name }}</span>
          </div>
          <div class="review-item">
            <span class="label">Subcategory:</span>
            <span class="value">{{ selectedSubcategory?.name }}</span>
          </div>
        </div>

        <div class="review-section">
          <h3>Listing Details</h3>
          <ng-container *ngFor="let field of formFields">
            <div class="review-item" *ngIf="getFieldValue(field.name)">
              <span class="label">{{ field.label }}:</span>
              <span class="value">{{
                formatFieldValue(field, getFieldValue(field.name))
              }}</span>
            </div>
          </ng-container>
        </div>

        <div class="review-section images" *ngIf="uploadedImageUrls.length > 0">
          <h3>Images ({{ uploadedImageUrls.length }})</h3>
          <div class="images-review-grid">
            <div
              *ngFor="let imageUrl of uploadedImageUrls"
              class="review-image-thumbnail"
            >
              <img [src]="imageUrl" [alt]="'Listing image'" />
            </div>
          </div>
        </div>

        <div
          class="review-section"
          *ngIf="isVehicleCategory && selectedFeatures.length > 0"
        >
          <h3>Selected Features</h3>
          <div class="selected-features-list">
            <ng-container *ngFor="let category of vehicleFeatures | keyvalue">
              <div
                *ngIf="getSelectedFeaturesInCategory(category.value).length > 0"
                class="feature-category-review"
              >
                <h4>{{ formatCategoryName(category.key) }}</h4>
                <div class="features-list">
                  <span
                    *ngFor="
                      let feature of getSelectedFeaturesInCategory(
                        category.value
                      )
                    "
                    class="feature-tag"
                  >
                    {{ feature.feature_name }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="review-section">
          <h3>Listing Plan & Duration</h3>
          <div class="plan-summary">
            <div class="plan-name">{{ selectedPlan?.name }} Plan</div>
            <div class="plan-cost" *ngIf="!usingFreeRelist">
              ${{ selectedPlan?.price === 0 ? "Free" : selectedPlan?.price }}
            </div>
            <div class="plan-cost free-relist-cost" *ngIf="usingFreeRelist">
              <span class="free-badge">🎁 FREE</span>
            </div>
          </div>
          <div class="plan-details">
            <div class="review-item">
              <span class="label">Duration:</span>
              <span class="value"
                >{{ selectedPlan?.features?.listingDuration }} days</span
              >
            </div>
            <div class="review-item">
              <span class="label">Expires on:</span>
              <span class="value">{{ formatExpirationDate() }}</span>
            </div>
            <div class="review-item">
              <span class="label">Images allowed:</span>
              <span class="value">{{
                selectedPlan?.features?.imagesAllowed
              }}</span>
            </div>
            <div class="review-item">
              <span class="label">Description limit:</span>
              <span class="value"
                >{{
                  selectedPlan?.features?.descriptionLength
                }}
                characters</span
              >
            </div>
          </div>
          <div class="balance-after">
            <span class="label">Balance after purchase:</span>
            <span class="amount" *ngIf="!usingFreeRelist">{{
              formatBalance(
                (currentUser?.balance || 0) - (selectedPlan?.price || 0)
              )
            }}</span>
            <span class="amount free-relist-text" *ngIf="usingFreeRelist">
              {{ formatBalance(currentUser?.balance) }}
              <small>(Free relist used - no charge)</small>
            </span>
          </div>
        </div>
      </div>

      <div class="step-actions"></div>
      <div class="step-actions">
        <button class="btn btn-secondary" (click)="previousStep()">Back</button>
        <button
          class="btn btn-primary"
          [disabled]="isSubmitting || showPublishingModal"
          (click)="submitListing()"
        >
          <span *ngIf="!isSubmitting && !showPublishingModal"
            >📋 Submit for Review</span
          >
          <span *ngIf="isSubmitting || showPublishingModal">
            <div class="spinner"></div>
            Submitting...
          </span>
        </button>
      </div>
    </div>

    <div class="publishing-modal-overlay" *ngIf="showPublishingModal">
      <div class="publishing-modal">
        <div class="publishing-modal-content">
          <div class="publishing-animation">
            <div class="publishing-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
          </div>

          <div class="publishing-header">
            <h2>📋 Submitting Your Listing</h2>
            <p>Please wait while we process your listing...</p>
          </div>

          <div class="progress-container">
            <div class="progress-bar-wrapper">
              <div
                class="progress-bar-fill"
                [style.width.%]="publishingProgress"
              ></div>
            </div>
            <div class="progress-text">
              <span class="progress-percentage">{{ publishingProgress }}%</span>
            </div>
          </div>

          <div class="publishing-stage">
            <div class="stage-text">{{ publishingStage }}</div>
          </div>

          <div class="stage-indicators">
            <div
              *ngFor="let stage of publishingStages; let i = index"
              class="stage-indicator"
              [class.completed]="publishingProgress >= stage.progress"
              [class.active]="i === currentStageIndex"
            >
              <div class="indicator-dot">
                <span *ngIf="publishingProgress >= stage.progress">✓</span>
                <span *ngIf="publishingProgress < stage.progress">{{
                  i + 1
                }}</span>
              </div>
              <span class="indicator-label">{{
                stage.name.replace("...", "")
              }}</span>
            </div>
          </div>

          <div class="listing-preview" *ngIf="publishingProgress > 30">
            <div class="preview-header">
              <h4>📝 Your Listing Preview</h4>
            </div>
            <div class="preview-content">
              <div class="preview-item">
                <span class="label">Category:</span>
                <span class="value">{{ selectedCategory?.name }}</span>
              </div>
              <div class="preview-item">
                <span class="label">Type:</span>
                <span class="value">{{ selectedSubcategory?.name }}</span>
              </div>
              <div class="preview-item">
                <span class="label">Plan:</span>
                <span class="value">{{ selectedPlan?.name }}</span>
              </div>
              <div class="preview-item" *ngIf="uploadedImageUrls.length > 0">
                <span class="label">Images:</span>
                <span class="value"
                  >{{ uploadedImageUrls.length }} uploaded</span
                >
              </div>
            </div>
          </div>

          <div class="publishing-warning">
            <div class="warning-content">
              <svg
                class="warning-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                ></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              <span
                >Please don't close this window or navigate away during
                publishing</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="success-modal-overlay"
      *ngIf="showPendingApprovalModal"
      (click)="closePendingApprovalModal()"
    >
      <div class="success-modal" (click)="$event.stopPropagation()">
        <div class="success-modal-content">
          <h2>📋 Listing Submitted Successfully!</h2>
          <p>
            Your listing has been submitted and is now
            <strong>pending admin review</strong>.
          </p>

          <div class="pending-info">
            <div class="info-card">
              <h4>📧 What happens next?</h4>
              <ul>
                <li>Our team will review your listing within 24 hours</li>
                <li>You'll receive an email once the review is done</li>
                <li>If approved, your listing goes live immediately</li>
              </ul>
            </div>

            <div class="balance-info" *ngIf="!usingFreeRelist">
              <div class="balance-item">
                <span class="label">Current Balance:</span>
                <span class="amount">{{
                  formatBalance(currentUser?.balance)
                }}</span>
              </div>
              <div class="balance-item pending">
                <span class="label">Will be charged on approval:</span>
                <span class="amount">{{
                  formatBalance(selectedPlan?.price)
                }}</span>
              </div>
            </div>

            <div class="relist-info" *ngIf="usingFreeRelist">
              <div class="relist-badge">
                🎁 Free relist credit will be used on approval - no charge!
              </div>
            </div>
          </div>

          <div class="listing-details">
            <div class="detail-item">
              <span class="detail-label">Plan:</span>
              <span class="detail-value">{{ selectedPlan?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Duration (once approved):</span>
              <span class="detail-value"
                >{{ selectedPlan?.features?.listingDuration }} days</span
              >
            </div>
            <div class="detail-item">
              <span class="detail-label">Images:</span>
              <span class="detail-value"
                >{{ uploadedImageUrls.length }} uploaded</span
              >
            </div>
          </div>

          <div class="modal-actions">
            <button
              class="btn btn-primary"
              (click)="closePendingApprovalModal()"
            >
              View My Listings
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="success-modal-overlay"
      *ngIf="showSuccessModal"
      (click)="closeSuccessModal()"
    >
      <div class="success-modal" (click)="$event.stopPropagation()">
        <div class="success-modal-content">
          <div class="success-icon">
            <div class="checkmark-circle">
              <div class="checkmark"></div>
            </div>
          </div>
          <h2>🎉 Listing Published Successfully!</h2>
          <p>
            Your listing is now pending review and will be visible to potential
            buyers once approved.
          </p>

          <div class="listing-details">
            <div class="detail-item">
              <span class="detail-label">Plan:</span>
              <span class="detail-value">{{ selectedPlan?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Duration:</span>
              <span class="detail-value"
                >{{ selectedPlan?.features?.listingDuration }} days</span
              >
            </div>
            <div class="detail-item">
              <span class="detail-label">Expires:</span>
              <span class="detail-value">{{ formatExpirationDate() }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Images:</span>
              <span class="detail-value"
                >{{ uploadedImageUrls.length }} uploaded</span
              >
            </div>
          </div>

          <div class="modal-actions">
            <button class="btn btn-primary" (click)="closeSuccessModal()">
              Go to My Listings
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="alert-container" *ngIf="successMessage || errorMessage">
      <div class="alert success" *ngIf="successMessage">
        <div class="alert-content">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <span>{{ successMessage }}</span>
        </div>
      </div>
      <div class="alert error" *ngIf="errorMessage">
        <div class="alert-content">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
